import z from "zod"

export const OutlookIntegrationCallbackSchema = z.object({
  code: z.string(),
})

export const OutlookIntegrationParams = z.object({
  id: z.string().transform(BigInt),
})

export const DiscoverOutlookMailboxesSchema = z.object({
  outlookAccountId: z.string().transform(BigInt),
})

export const ValidateOutlookMailboxSchema = z.object({
  outlookAccountId: z.string().transform(BigInt),
  email: z
    .string()
    .email()
    .transform((value) => value.toLowerCase()),
})

export const SetOutlookMailboxesSchema = z.object({
  outlookAccountId: z.string().transform(BigInt),
  emails: z
    .array(
      z
        .string()
        .email()
        .transform((value) => value.toLowerCase()),
    )
    .min(1),
})
